// @ts-nocheck
import React from 'react'
import { $createParagraphNode, $createTextNode, $getRoot } from 'lexical'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import * as R from 'ramda'

import { $createTextVariableNode } from 'components/shared/FormFields/common/Editors/nodes/TextVariableNode/TextVariableNode'

export const InitialStatePlugin = ({ value, variables }) => {
  const [editor] = useLexicalComposerContext()

  const isInitialLoad = React.useRef(true)

  React.useEffect(() => {
    editor.update(() => {
      const root = $getRoot()

      if (!value || R.equals(isInitialLoad.current, R.F())) {
        return
      }

      if (value) {
        isInitialLoad.current = false
        root.clear()
      }

      const paragraph = $createParagraphNode()

      R.pipe(
        R.split(/(\{{2}\s\w*\s\}{2})/g),
        R.map(chunk => {
          if (chunk.startsWith('{{') && chunk.endsWith('}}')) {
            const { key, label } =
              R.find(R.propEq('key', /\w+/g.exec(chunk)?.[0]))(variables) ?? {}

            return $createTextVariableNode(key, label)
          }

          return $createTextNode(chunk)
        }),
        R.forEach(node => {
          paragraph.append(node)
          root.append(paragraph)
        }),
      )(value)
    })
  }, [editor, value, variables, isInitialLoad])

  React.useEffect(() => {
    return () => {
      editor.update(() => {
        const root = $getRoot()
        root.clear()
      })
    }
  }, [editor])

  return null
}
